import PaginationRequestData from '@/calendesk/models/DTO/Request/PaginationRequestData'

export default class UserSubscriptionPaymentTransactionsRequestData extends PaginationRequestData {

}
